import { useI18n } from "@/i18n/I18nProvider";
import { SEO } from "@/components/SEO";
import { Breadcrumbs } from "@/components/Breadcrumbs";
import { InternalLinks } from "@/components/InternalLinks";
import { CasinoCard } from "@/components/CasinoCard";
import { listCasinos } from "@/data/casinos";

export function NewCasinosPage() {
  const { t, lang, prefix } = useI18n();
  const isSv = lang === "sv";
  const casinos = listCasinos().sort(
    (a, b) => (b.launch_year ?? 0) - (a.launch_year ?? 0),
  );
  const title = isSv ? "Nya casinon i Sverige 2026" : "New casinos in Sweden 2026";
  const desc = isSv
    ? "Nyligen lanserade casinon för svenska spelare. Vi listar nya operatörer både med och utan svensk licens."
    : "Recently launched casinos for Swedish players. We list new operators with and without Swedish license.";
  return (
    <div className="container-page py-8">
      <SEO title={title} description={desc} />
      <Breadcrumbs items={[{ label: t("nav.home"), href: prefix }, { label: title }]} />
      <h1 className="mt-3 text-3xl font-extrabold md:text-4xl">{title}</h1>
      <p className="mt-2 max-w-3xl text-ink-700">{desc}</p>

      <article className="prose prose-ink mt-6 max-w-3xl [&>h2]:mt-8 [&>h2]:mb-3 [&>h2]:text-2xl [&>h2]:font-bold [&>p]:my-3">
        <h2>{isSv ? "Vad är ett ”nytt” casino?" : "What is a ”new” casino?"}</h2>
        <p>
          {isSv
            ? "Hos oss räknas ett casino som nytt om det fått sin licens (eller relanserats med ny ägare/varumärke) inom de senaste 12 månaderna. Nya casinon erbjuder ofta en fräsch teknisk plattform, snabbare betalningar och mer utrymme för innovation — men de saknar långsiktig statistik som etablerade operatörer har byggt upp."
            : "We classify a casino as new if it received its license (or relaunched under new ownership) within the past 12 months. New casinos often ship a fresh tech stack, faster payments and more room to innovate — but they lack the long-term operational track record of established operators."}
        </p>
        <h2>{isSv ? "Vad du ska kontrollera" : "What to check"}</h2>
        <p>
          {isSv
            ? "Licensnummer hos Spelinspektionen, ägarstrukturen, vilka licensjurisdiktioner moderbolaget verkar i, och hur deras kundsupport reagerar på enkla frågor innan du sätter in pengar. En ny operatör är inte automatiskt sämre — men du tar lite mer risk genom att vara tidig spelare."
            : "License number with Spelinspektionen, the ownership structure, the jurisdictions the parent operates in, and how customer support responds to simple questions before you deposit. A new operator is not automatically worse — but being an early player carries a little more risk."}
        </p>
      </article>

      <h2 className="mt-10 text-2xl font-bold">
        {isSv ? "Nyaste casinon vi täcker" : "Newest casinos we cover"}
      </h2>
      <div className="mt-4 grid gap-4">
        {casinos.map((c, i) => (
          <CasinoCard key={c.id} casino={c} rank={i + 1} source="new-list" />
        ))}
      </div>

      <InternalLinks context="casino-list" />
    </div>
  );
}
